export default "/images/project1.jpg?7528795f21d55d264720f4ed715e76ed";